// extracted by mini-css-extract-plugin
export var settingsList = "_35-0";
export var settingsRow = "_35-1";
export var warningDot = "_35-2";